// extracted by mini-css-extract-plugin
export var addressFields = "_ie-0";
export var animationContainer = "_ie-1";
export var footer = "_ie-2";
export var lineItems = "_ie-3";
export var modalContent = "_ie-4";
export var orderName = "_ie-5";
export var strong = "_ie-6";
export var warning = "_ie-7";